import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';

import { useImpersonation } from '../contexts/ImpersonationContext';

// Sits above the regular AppBar whenever a system admin is "viewing as"
// another user. Loud orange so it's impossible to forget.
export default function ImpersonationBanner() {
  const { target, stop } = useImpersonation();

  if (!target) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        bgcolor: '#ff5722',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 0.75,
        px: 2,
        fontSize: 13,
      }}
    >
      <VisibilityIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
        Viewing as {target.fullName || target.email}
      </Typography>
      <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
        ({target.email})
      </Typography>
      <Button
        size="small"
        startIcon={<LogoutIcon sx={{ fontSize: 14 }} />}
        onClick={stop}
        sx={{
          ml: 1,
          color: '#fff',
          borderColor: 'rgba(255,255,255,0.55)',
          textTransform: 'none',
          fontSize: 12,
          '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.12)' },
        }}
        variant="outlined"
      >
        Exit
      </Button>
    </Box>
  );
}
